const copyText = (text) => {
	if (navigator.clipboard && window.isSecureContext) {
		return navigator.clipboard.writeText(text);
	}

	// Zapasowo: stara metoda przez ukryte pole tekstowe
	return new Promise((resolve, reject) => {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();

		const ok = document.execCommand('copy');
		document.body.removeChild(textarea);

		ok ? resolve() : reject(new Error('copy failed'));
	});
};

export const initContact = () => {
	const timeouts = new WeakMap();

	document.addEventListener('click', (e) => {
		const btn = e.target.closest('.js-copy');
		if (!btn) return;

		const status = btn.parentElement.querySelector('.js-copy-status');

		copyText(btn.dataset.copy)
			.then(() => {
				if (status) status.textContent = 'Skopiowano!';
			})
			.catch(() => {
				if (status) status.textContent = 'Nie udało się skopiować';
			});

		clearTimeout(timeouts.get(btn));
		timeouts.set(
			btn,
			setTimeout(() => {
				if (status) status.textContent = '';
			}, 2500)
		);
	});
};
